import { ref } from 'vue'
import { signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { auth } from '@/firebase'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase'
import { useProgram } from '@/composables/useProgram'

export function useAuth() {
    const errorMessage = ref('')
    const { program } = useProgram()

    const handleLogin = async (email, password) => {
        try {
            const result = await signInWithEmailAndPassword(auth, email, password)
            const user = result.user

            const accessGranted = await validateAccess(user.uid)
            if (!accessGranted) {
                await signOut(auth)
                return null
            }

            return { authUser: user }
        } catch (error) {
            console.error('Login error:', error.message)
            errorMessage.value = 'Invalid email or password.'
            return null
        }
    }

    const validateAccess = async (uid) => {
        try {
            if (!program.value?.nick) {
                console.error('Program nick not available')
                return false
            }

            const userDocRef = doc(db, `users/${program.value.nick}/users`, uid)
            const userDoc = await getDoc(userDocRef)

            if (!userDoc.exists()) {
                console.warn('No Firestore user data found for UID.')
                return false
            }

            const userData = userDoc.data()

            if (!userData.active) {
                console.warn('Account is inactive.')
                return false
            }

            if (userData.role !== 'admin' && userData.nick !== program.value.nick) {
                console.warn('Access denied for non-admin user.')
                return false
            }

            return true
        } catch (error) {
            console.error('Validation error:', error.message)
            return false
        }
    }

    return {
        handleLogin,
        validateAccess,
        errorMessage
    }
}